import useSWRImmutable from 'swr/immutable'

import { fetchCMSMenu, getCMSMenuSWRKey } from '@/src/domains/cms-menus/services/fetchCMSMenu'
import type { FetchStrapiMenu } from '@/src/domains/strapi/services/fetchStrapiMenu'

export const useCMSMenu = (slug: FetchStrapiMenu['slug']) => {
  const swr = useSWRImmutable(getCMSMenuSWRKey(slug), () => fetchCMSMenu(slug), {
    suspense: true,
  })

  return swr
}
